import { render, staticRenderFns } from "./delete_dialog.vue?vue&type=template&id=a82f473a"
import script from "./delete_dialog.vue?vue&type=script&lang=js"
export * from "./delete_dialog.vue?vue&type=script&lang=js"
import style0 from "./delete_dialog.vue?vue&type=style&index=0&id=a82f473a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports